<template>
  <div class="form-payer-container">
    <Panel
      title="2.ข้อมูลส่วนบุคคลของผู้ชำระเบี้ยประกันภัย"
      optionText="ข้อมูลเดียวกับผู้ขอเอาประกันภัย"
      isShowOptionCheckbox
      :isCheckOption="isPaidByInsuredPerson"
      :onCheckOptionCallback="checkPaidByInsuredPerson"
      :isOptionsDisabled="disabledForm || this.checkDisabledPaidByInsuredPersonCheckbox()"
    >
      <div class="customer-inquiry-section row">
        <div class="form-group col-sm-5">
          <div class="input-group">
            <span class="input-group-addon nobd-nobg">ประเภทบัตร</span>
            <Dropdown
              class="form-control input-sm"
              :options="identityOptions"
              v-model="customerIdentity.type"
              :selectedValue="customerIdentity.type"
              :disabled="disabledForm || this.checkDisabledPayerIdentitySection()"
            />
          </div>
        </div>
        <div class="form-group col-sm-7">
          <div class="input-group">
            <span class="input-group-addon nobd-nobg tx-card-rm">{{ renderIdentityText() }}</span>
            <input
              type="text"
              class="form-control input-sm"
              :class="{
                'bd-red': errors.has('identityNumber') || !verifyCitizen(),
              }"
              :maxlength="customerIdentity.type === 'idCard' ? 13 : ''"
              name="identityNumber"
              v-model="customerIdentity.number"
              :disabled="disabledForm || this.checkDisabledPayerIdentitySection()"
            />
          </div>
        </div>
        <div class="customer-inquiry-btn-container text-center">
          <Button
            class="btn-dark btn-s-xs"
            type="info"
            data-type="amlo-pass"
            @click.native="triggerGetCustomerInquiry"
            :disabled="disabledForm || this.checkDisabledPayerIdentitySection()"
          >
            <i class="fa fa-search"></i> ค้นหา
          </Button>
        </div>
      </div>
      <div class="customer-check-amlo-section row">
        <div class="form-insured-name-section clearfix">
          <div class="form-group col-sm-3">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">คำนำหน้าชื่อ</span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="customerInformation.namePrefix"
                disabled
              />
            </div>
          </div>
          <div class="form-group col-sm-4">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">ชื่อ</span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="customerInformation.firstname"
                disabled
              />
            </div>
          </div>
          <div class="form-group col-sm-5">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">นามสกุล</span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="customerInformation.lastname"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="form-insured-contact-section clearfix">
          <div class="email-form-group form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">อีเมล</span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="customerInformation.email"
                disabled
              />
            </div>
          </div>
          <div class="phone-form-group form-group col-sm-6">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">โทรศัพท์มือถือ</span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="customerInformation.phone"
                disabled
              />
            </div>
            <div class="warning-text">
              “หากท่านระบุเบอร์โทรศัพท์มือถือไม่ถูกต้อง
              จะไม่สามารถทำการชำระเงินด้วยวิธีการหักผ่านบัญชี ttb ได้”
            </div>
          </div>
        </div>
        <div class="customer-check-amlo-btn-container text-center">
          <Button
            class="btn-dark btn-s-xs"
            :type="!isCheckAmloSuccess ? 'info' : isPassAmlo ? 'primary' : 'danger'"
            data-type="amlo-pass"
            @click.native="verifyAmloPayer"
            :disabled="disabledForm || this.checkDisabledPayerInformationSection()"
          >
            <i
              class="fa"
              :class="{
                'fa-search': !isCheckAmloSuccess,
                'fa-check-circle-o': isCheckAmloSuccess && isPassAmlo,
                'fa-times-circle-o': isCheckAmloSuccess && !isPassAmlo,
              }"
            />
            <span v-if="!isCheckAmloSuccess"> ตรวจสอบ AMLO</span>
            <span v-else>{{ isPassAmlo ? ' ผ่าน AMLO' : ' ไม่ผ่าน AMLO' }}</span>
          </Button>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'

import Button from '@/components/Button'
import Dropdown from '@/components/Dropdown'
import Panel from '@/components/Panel'
import { identityNumberText, passportNumberText, validationRule } from '@/lib/global'
import { generateAuthorizationRequestHeader, validateCitizenNumber } from '@/lib/services'
import Vue from 'vue'
import API from '@/lib/api'

const { mapFields: mapQuotationFields } = createHelpers({
  getterType: 'getQuotationFields',
  mutationType: 'updateQuotationFields',
})

export default {
  name: 'PayerForm',
  props: ['typeInsurance', 'quotationId', 'disabledForm'],
  validator: null,
  data() {
    return {
      identityOptions: [
        {
          value: 'idCard',
          description: 'บัตรประจำตัวประชาชน',
        },
        {
          value: 'passport',
          description: 'เลขที่หนังสือเดินทาง',
        },
      ],
      rules: {
        identityNumber: 'required|numeric|min:13|max:13',
      },
      errors: null,
      isQuotationNotRm: null,
    }
  },
  computed: {
    ...mapQuotationFields({
      insuredDetailInformation: 'insuredDetail.data',
      isValidateInsuredSuccess: 'insuredDetail.data.isValidateInformationSuccess',
      payerId: 'payerInformation.data.payerId',
      isPaidByInsuredPerson: 'payerInformation.data.isPaidByInsuredPerson',
      customerIdentity: 'payerInformation.data.customerIdentity',
      customerInformation: 'payerInformation.data.customerInformation',
      isGetCustomerIdentitySuccess: 'payerInformation.data.isGetCustomerIdentitySuccess',
      isCheckAmloSuccess: 'payerInformation.data.isCheckAmloSuccess',
      isPassAmlo: 'payerInformation.data.isPassAmlo',
      isValidateInformationSuccess: 'payerInformation.data.isValidateInformationSuccess',
    }),
  },
  components: {
    Button,
    Dropdown,
    Panel,
  },
  watch: {
    'customerIdentity.type'(val) {
      if (!this.isPaidByInsuredPerson) {
        this.customerIdentity.number = null
      }

      const { idCard, passport } = validationRule.customerIdentity

      const isIdCardType = val === 'idCard'
      this.rules.identityNumber = isIdCardType ? idCard : passport

      this.setRule()
    },
    'customerIdentity.number'(val) {
      if (val) {
        this.validator.validate('identityNumber', val)
      }
    },
    isPaidByInsuredPerson() {
      if (this.isPaidByInsuredPerson && !this.payerId) {
        const { customerIdentity, customerInformation } = this.insuredDetailInformation
        const { type, number } = customerIdentity
        const { namePrefix, firstname, lastname, email, phone } = customerInformation

        this.customerIdentity = {
          type,
          number,
        }
        this.customerInformation = {
          namePrefix,
          firstname,
          lastname,
          email,
          phone,
        }

        if (this.isQuotationNotRm === false) {
          this.verifyAmloPayer()
        } else if (this.isQuotationNotRm === true) {
          this.manualAmloPayer()
        }
      }
    },
  },
  methods: {
    ...mapActions(['getCustomerInquiryInformation', 'checkRiskPayer', 'manualCheckRiskPayer']),
    renderIdentityText() {
      return this.customerIdentity.type === 'idCard' ? identityNumberText : passportNumberText
    },
    verifyCitizen() {
      const idNumber = this.customerIdentity.number
      if (this.customerIdentity.type === 'idCard' && idNumber) {
        return validateCitizenNumber(idNumber)
      }
      return true
    },
    checkPaidByInsuredPerson($evt) {
      this.isPaidByInsuredPerson = $evt.target.checked
    },
    checkDisabledPaidByInsuredPersonCheckbox() {
      if (
        !this.isValidateInsuredSuccess ||
        this.isPaidByInsuredPerson ||
        this.isValidateInformationSuccess
      ) {
        return true
      }

      return false
    },
    checkDisabledPayerIdentitySection() {
      if (
        !this.isValidateInsuredSuccess ||
        this.isPaidByInsuredPerson ||
        this.isGetCustomerIdentitySuccess
      ) {
        return true
      }

      return false
    },
    checkDisabledPayerInformationSection() {
      if (
        !this.isValidateInsuredSuccess ||
        this.isPaidByInsuredPerson ||
        !this.isGetCustomerIdentitySuccess ||
        this.isCheckAmloSuccess ||
        this.isValidateInformationSuccess
      ) {
        return true
      }

      return false
    },
    triggerGetCustomerInquiry() {
      const cardPersonalType = this.customerIdentity.type
      const citizenId = this.customerIdentity.number

      this.validator
        .validateAll({
          identityNumber: citizenId,
        })
        .then((validationResult) => {
          if (validationResult && this.verifyCitizen()) {
            this.getCustomerInquiryInformation({
              field: 'payerInformation',
              cardType: cardPersonalType === 'idCard' ? 'CI' : 'PP',
              citizenId,
            })
          }
        })
    },
    verifyAmloPayer() {
      const cardPersonalType = this.customerIdentity.type
      const citizenId = this.customerIdentity.number
      const isPaidByInsuredPerson = this.isPaidByInsuredPerson

      const cardType = cardPersonalType === 'idCard' ? 'CI' : 'PP'

      this.checkRiskPayer({ cardType, citizenId, isPaidByInsuredPerson })
    },
    manualAmloPayer() {
      const cardPersonalType = this.customerIdentity.type
      const citizenId = this.customerIdentity.number
      const isPaidByInsuredPerson = this.isPaidByInsuredPerson
      const cardType = cardPersonalType === 'idCard' ? 'CI' : 'PP'
      this.manualCheckRiskPayer({ cardType, citizenId, isPaidByInsuredPerson })
    },
    clearErrors() {
      this.errors.clear()
    },
    setRule() {
      this.validator = new Validator(this.rules)
      this.$set(this, 'errors', this.validator.errors)
    },
    checkRmQuotation: async function () {
      const [, , quotationId] = this.$route.path.split('/')
      if (!quotationId) return null
      const headers = generateAuthorizationRequestHeader()
      const url = API.QUOTATION.CHECK_RM_QUOTATION(quotationId)
      const resp = await Vue.http.get(url, { headers })
      const { result } = await resp.json()
      return result.isNotRm
    },
  },
  created() {
    this.setRule()
  },
  async mounted() {
    this.isQuotationNotRm = await this.checkRmQuotation()
  },
}
</script>

<style lang="scss">
.form-payer-container {
  .customer-inquiry-section {
    margin-bottom: 32px;
  }

  .customer-check-amlo-section {
    .form-insured-contact-section {
      .phone-form-group {
        .warning-text {
          color: #eb5757;
          font-size: 12px;
          line-height: 16px;
          margin-top: 8px;
          margin-left: 95px;
        }
      }
    }
  }
}
</style>
